var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.27148 8.5485L1.22165 9.58692L0.194524 8.5485L1.22165 7.51008L2.27148 8.5485ZM24.421 18.9985C24.421 19.8141 23.7599 20.4752 22.9444 20.4752C22.1289 20.4752 21.4677 19.8141 21.4677 18.9985L24.421 18.9985ZM7.68194 16.1182L1.22165 9.58692L3.32131 7.51008L9.78159 14.0414L7.68194 16.1182ZM1.22165 7.51008L7.68194 0.978811L9.78159 3.05565L3.32131 9.58692L1.22165 7.51008ZM2.27148 7.07187L18.5145 7.07186L18.5145 10.0251L2.27148 10.0251L2.27148 7.07187ZM24.421 12.9784L24.421 18.9985L21.4677 18.9985L21.4677 12.9784L24.421 12.9784ZM18.5145 7.07186C21.7766 7.07186 24.421 9.71631 24.421 12.9784L21.4677 12.9784C21.4677 11.3474 20.1455 10.0251 18.5145 10.0251L18.5145 7.07186Z",
    fill: "#304A38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.21d6914eae1e35bca5349aee821266d9.svg";
export { ForwardRef as ReactComponent };